import { render, staticRenderFns } from "./LocationsStandalone.vue?vue&type=template&id=44793afe&scoped=true"
import script from "./LocationsStandalone.vue?vue&type=script&lang=js"
export * from "./LocationsStandalone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../Library/WebServer/Documents/LSA-New-V2/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44793afe",
  null
  
)

export default component.exports